import {MaterialType, MaterialWithRecipes} from '@domain/materials'
import {useIsMutating} from '@tanstack/react-query'
import {useMemo} from 'react'

import {useAnyPermission} from '../../../../permissions'
import {CHANGE_MATERIALS_PERMISSION_TYPES} from '../../../consts'

import {AdditivesForClinkerClassification} from './AdditivesForClinkerClassification'
import {CementClassification} from './CementClassification'
import {ClinkerClassification} from './ClinkerClassification'
import {EnhancersForCementClassification} from './EnhancersForCementClassification'
import {FuelsClassification} from './FuelsClassification'
import {IntermediateAndFinishedProductsClassification} from './IntermediateAndFinishedProductsClassification'
import {OtherGroundProductsThanCementClassification} from './OtherGroundProductsThanCementClassification'
import {OtherPyroProductsThanClinkerClassification} from './OtherPyroProductsThanClinkerClassification'
import {RawMaterialsClassification} from './RawMaterialsClassification'

interface MaterialSettingsClassificationTabProps {
  material: MaterialWithRecipes
}

export const MaterialSettingsClassificationTab: React.FC<
  MaterialSettingsClassificationTabProps
> = ({material}) => {
  const canChangeMaterials = useAnyPermission(...CHANGE_MATERIALS_PERMISSION_TYPES)

  const runningMutations = useIsMutating({mutationKey: ['editMaterial']})
  const isMaterialSaving = Boolean(runningMutations)

  const ClassificationTabComponent = useMemo(() => {
    switch (material.type) {
      case MaterialType.Cement:
        return CementClassification
      case MaterialType.Clinker:
        return ClinkerClassification
      case MaterialType.Fuels:
        return FuelsClassification
      case MaterialType.RawMaterials:
        return RawMaterialsClassification
      case MaterialType.EnhancersForCement:
        return EnhancersForCementClassification
      case MaterialType.IntermediateAndFinishedProducts:
        return IntermediateAndFinishedProductsClassification
      case MaterialType.AdditivesForClinker:
        return AdditivesForClinkerClassification
      case MaterialType.OtherGroundProductsThanCement:
        return OtherGroundProductsThanCementClassification
      case MaterialType.OtherPyroProductsThanClinker:
        return OtherPyroProductsThanClinkerClassification
      default:
        throw new Error(`BUG: Unknown material type: ${material.type}`)
    }
  }, [material.type])

  return <ClassificationTabComponent isDisabled={!canChangeMaterials || isMaterialSaving} />
}
